export default __webpack_public_path__ + "static/media/scala.e5b12dd4.png";